<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import {Button} from "@/components/ui/button"
import {Users, Building2, FolderOpen, Activity} from "lucide-vue-next"
import {OrgSelector} from '@/components/filters'
import {DialogCreateProject} from '@/components/dialogs'
import AdminNavigation from '@/components/admin/AdminNavigation.vue'
import {API, HOST} from '@/utils/http'
import { toast } from '@/components/ui/toast'
import Card from '@/components/cards/Card.vue'

const router = useRouter()
const store = useStore()
const member = computed(() => store.getters.getMember)

const stats = ref(null)

onMounted(async () => {
  try {
    const response = await API({
      method: 'GET',
      url: `${HOST}/stats`
    })

    stats.value = response.data ? response.data : null
  } catch (error) {
    toast({
      title: `Failed to fetch stats: ${error.message}`
    })
  }
})

watch(() => member.value, (value) => {
  if (!value) {
    return
  }

  if (!value.is_super_user) {
    router.push({name: 'Dashboard'})
  }
})
</script>

<template>
  <div v-if="member && member.is_super_user" class="h-full flex flex-col">
    <AdminNavigation />
    <div class="p-6 space-y-4 flex-1 overflow-auto">
    <ul>
      <li>Total Orgs: {{ stats?.total_organizations || 0 }}</li>
      <li>Total Projects: {{ stats?.total_projects || 0 }}</li>
      <li>Total Users: {{ stats?.total_members || 0 }}</li>
    </ul>

    </div>
  </div>
</template>
